import { CreateInstance } from "./config"
const RemoteAccessAgreementAPI = CreateInstance("remote_access_agreement")
export default RemoteAccessAgreementAPI
